import React, { Component } from 'react';
import '../style/formGroupTextArea.css'
import $ from 'jquery';
import FormGroupPlainText from "./formGroupPlainText";

class FormGroupTextArea extends Component{

    validateOnChange = () => {
        var textarea = this._val;
        if(!$(textarea).prop('required')){
            return 0;
        }
        var errorMsg = 'Whitespaces are not allowed.';
        var pattern = new RegExp($(textarea).attr('pattern'));

        // check if the value matches the pattern
        var hasError = !$(textarea).val().match(pattern);
        if (typeof textarea.setCustomValidity === 'function') {
            textarea.setCustomValidity(hasError ? errorMsg : '');
        } else {
            // Not supported by the browser, fallback to manual error display...
            $(textarea).toggleClass('error', !!hasError);
            $(textarea).toggleClass('ok', !hasError);
            if (hasError) {
                $(textarea).attr('title', errorMsg);
            } else {
                $(textarea).removeAttr('title');
            }
        }
        return !hasError;
    };

    render() {
        const {isPlain, labelAsALink, onLabelClick} = this.props;
        if(isPlain) {
            return (
                <FormGroupPlainText
                    labelAsALink={labelAsALink}
                    onLabelClick={onLabelClick}
                    RightWrapper={this.props.RightWrapper}
                    rightData={this.props.rightData}
                    LeftWrapper="col-sm-3"
                    InputWrapper={this.props.centerWrapper}
                    Label={this.props.Label}
                    Text={this.props.Value}
                />
            )
        }

        let rows = 5;
        if (this.props.rows) {
            rows = this.props.rows;
        }
        let pattern = this.props.pattern;
        let title = this.props.title;
        if(!pattern && this.props.required){
            pattern = '.*\\S.*' ;
            title = 'Whitespaces are not allowed.'
        }
        return (
            <div className="form-group">
                <div className="col-sm-3">
                    <label className={"control-label.text-left  formGroupTextArea-label " +
                    (this.props.required?' inputRequired':'')
                    }>
                        {this.props.Label}
                    </label>
                </div>
                <div className={this.props.centerWrapper}>
                <textarea value={this.props.Value} required={this.props.required} name={this.props.Name}
                          pattern={pattern}
                          title={title}
                          className="form-control formGroupTextArea-textArea" rows={rows}
                          onChange={(evt) => { this.props.HandleInputChange(evt.target.name, evt.target.value);
                          this.validateOnChange()
                          } }
                          ref={a => this._val = a}
                />
                </div>
                <div className={this.props.RightWrapper}>{this.props.rightData ? this.props.rightData : null}</div>
            </div>
        )
    }
}

export default FormGroupTextArea;
